import React from 'react'

function PageNotFound() {
  return (
    <div>404 Page Not Found</div>
  )
}

export default PageNotFound